import { Component } from '@angular/core'

@Component({
  selector: 'se-po-graduation-select-docs',
  templateUrl: './graduation-select-docs.component.html',
  styleUrls: ['./graduation-select-docs.component.scss'],
  standalone: false,
})
export class GraduationSelectDocsComponent {
}
